import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, of } from 'rxjs';
import { COUNTRIES } from './countries';

type GlobalstarChannel = 'A' | 'C';
// Fixed list of channel A Globalstar countries. Other countries are channel C
const CHANNEL_A_COUNTRIES = [
  'Bahamas',
  'Belize',
  'El Salvador',
  'Guatemala',
  'Honduras',
  'Cuba',
  'Nicaragua',
  'Canada',
  'Mexico',
  'United States',
];
export type Country = {
  commonName: string;
  officialName: string;
  globalstarChannel: GlobalstarChannel;
};
interface State {
  countries: Country[];
  loaded: boolean;
  error: string | null;
}

@Injectable({ providedIn: 'root' })
export class CountriesService {
  private httpClient = inject(HttpClient);

  //state
  private state = signal<State>({
    countries: [],
    loaded: false,
    error: null,
  });

  // selectors
  loaded = computed(() => this.state().loaded);
  countries = computed(() => this.state().countries);
  countriesCommonNames = computed(() => this.countries().map((country) => country.commonName));

  // sources
  #countriesLoaded = this.fetchAllCountries();

  constructor() {
    // reducers
    this.#countriesLoaded
      .pipe(
        takeUntilDestroyed(),
        map((countries) =>
          countries
            .map(
              (country) =>
                ({
                  commonName: country.commonName,
                  officialName: country.officialName,
                  globalstarChannel: CHANNEL_A_COUNTRIES.includes(country.commonName) ? 'A' : 'C',
                }) as Country,
            )
            .sort((a, b) => a.commonName.localeCompare(b.commonName)),
        ),
      )
      .subscribe((countries) =>
        this.state.update((state) => ({ ...state, countries: countries, loaded: true })),
      );
    // effects
  }

  private fetchAllCountries() {
    return of(COUNTRIES);
  }
}
